module.exports = __webpack_public_path__ + "static/media/resourceBookletImage.69119492.png";